"use strict";

$(document)
    // http://bt.web100.com.ua/view.php?id=49915 - убиваем нативный функционал в угоду каким-то странным соображениям
    .on("dragstart", function (e) {
        if (!$(e.target).closest(".ui-draggable").length) {
            e.preventDefault();
        }
    })
;

$(window)
    .resize(function () {
        //0049135: центрировать все диалоги при ресайзе
        //0051143: не для всех диалогов получается получить инстанс, например колорпикер для текстового блока
        $('.ui-dialog-content').each(function () {
            var dlg = $(this).dialog('instance');
            if (dlg !== undefined && $(this).dialog('isOpen') && $(this).dialog('option', 'modal')) {
                $(this).dialog('option', 'position', {'my': 'center', 'at': 'center', 'of': window});
            }
        });

        $('.ui-autocomplete').css('display', 'none');
    });
